/* eslint-disable no-unused-vars */
import {
  BaSeDataTable,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import { format, parseISO } from 'date-fns';
import React from 'react';
import { cpfMask } from '../../../../utils/formatters/cpfMask';
import { phoneMask } from '../../../../utils/formatters/phoneMask';
import { useCandidateInterview } from '../../pages/candidates/hook/useCandidateInterview';

function VisualizarDadosCadastrais({ values }) {
  const { formatDate } = useCandidateInterview();

  const configTable = [
    {
      accessorKey: 'city.uf.initials',
      header: 'UF',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {values.city.uf.initials}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'city.name',
      header: 'Cidade',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {values.city.name}
        </BaSeSmall1>
      ),
    },
    {
      id: 'cpf',
      header: 'CPF',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {cpfMask(values.candidate.cpf)}
        </BaSeSmall1>
      ),
    },
    {
      id: 'contatos',
      header: 'Contatos',
      mapper: ({ values }) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {phoneMask(values.phone ?? '')}
          </BaSeSmall1>
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {values.email}
          </BaSeSmall1>
        </div>
      ),
    },
    {
      id: 'dataNascimento',
      header: 'Data de nascimento',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {values.candidate.birthDate
            ? format(parseISO(values.candidate.birthDate), 'dd/MM/yyyy')
            : 'Não informado'}
        </BaSeSmall1>
      ),
    },
  ];

  return (
    <>
      <BaSeDataTable
        config={configTable}
        shadow="0"
        items={[values]}
        width="900"
        title={`${values?.candidate.name}`}
        configActionItemsProps={{ icon: 'ellipsis-v' }}
      />
      {values?.candidate?.emergencyContact !== undefined && (
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          Em caso de emergência, entre em contato com{' '}
          {values?.candidate?.emergencyContact?.emergencyContactName}, contato{' '}
          {phoneMask(
            values?.candidate?.emergencyContact?.emergencyContactPhone,
          )}
          .
        </BaSeParagraph>
      )}
    </>
  );
}

export default VisualizarDadosCadastrais;
